var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFrontCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic-front-card",
    d: "M16.5,32H1.5A1.5,1.5,0,0,0,0,33.5v11A1.5,1.5,0,0,0,1.5,46h15A1.5,1.5,0,0,0,18,44.5v-11A1.5,1.5,0,0,0,16.5,32Zm0,12.5H1.5v-11h15ZM6.5,39a2,2,0,1,0-2-2A2,2,0,0,0,6.5,39ZM3.7,43H9.3a.655.655,0,0,0,.7-.6v-.6A1.968,1.968,0,0,0,7.9,40a7.545,7.545,0,0,1-1.4.25A7.435,7.435,0,0,1,5.1,40,1.968,1.968,0,0,0,3,41.8v.6A.655.655,0,0,0,3.7,43Zm7.55-2h3.5a.251.251,0,0,0,.25-.25v-.5a.251.251,0,0,0-.25-.25h-3.5a.251.251,0,0,0-.25.25v.5A.251.251,0,0,0,11.25,41Zm0-2h3.5a.251.251,0,0,0,.25-.25v-.5a.251.251,0,0,0-.25-.25h-3.5a.251.251,0,0,0-.25.25v.5A.251.251,0,0,0,11.25,39Zm0-2h3.5a.251.251,0,0,0,.25-.25v-.5a.251.251,0,0,0-.25-.25h-3.5a.251.251,0,0,0-.25.25v.5A.251.251,0,0,0,11.25,37Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFrontCard);
export default __webpack_public_path__ + "static/media/ic-front-card.363aab4c541b16f0ed1da25a460f8ece.svg";
export { ForwardRef as ReactComponent };